import { useQuery, QueryHookOptions } from '@apollo/client';
import { GET_FEATURED_CARS } from './queries';

export const FEATURED_CARS_DISPLAY_COUNT = 8;

export type FeaturedCarCategory =
  | 'SUV'
  | 'MINIVAN'
  | 'SEDAN'
  | 'VAN'
  | 'CARGO_VAN'
  | 'BOX_TRUCK'
  | 'WAGON'
  | 'SUBRUBAN'
  | 'COUPE'
  | 'TRUCK'
  | 'CONVERTIBLE'
  | 'OTHERS';

export type GetFeaturedCarsInput = {
  type?: string;
  siteHost?: string;
  category?: FeaturedCarCategory;
  limit?: number;
};

export type FeaturedCar = {
  id: string;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  category?: string | null;
  weekdayPrice?: number | null;
  monthlyPrice?: number | null;
  monthlyRentalIsOn?: boolean | null;
  thumbnailUrl?: string | null;
  isCreated?: boolean | null;
  /** Spec 022: the week price for the card and the trip length cap (Weekly tab). */
  tripSettings?: {
    maximumRentalDays?: number | null;
    displayPrices?: { oneWeek?: number | null } | null;
  } | null;
};

export type GetFeaturedCarsQueryData = {
  getFeaturedCars: FeaturedCar[];
};

export type GetFeaturedCarsQueryVars = {
  input?: GetFeaturedCarsInput;
};

/** Homepage category chips use lowercase ids (`suv`); backend CategoryEnum is uppercase. */
export function homepageCategoryToApi(selectedCategory?: string): FeaturedCarCategory | undefined {
  if (!selectedCategory || selectedCategory === 'all') {
    return undefined;
  }
  const upper = selectedCategory.toUpperCase();
  const allowed: FeaturedCarCategory[] = [
    'SUV',
    'MINIVAN',
    'SEDAN',
    'VAN',
    'CARGO_VAN',
    'BOX_TRUCK',
    'WAGON',
    'SUBRUBAN',
    'COUPE',
    'TRUCK',
    'CONVERTIBLE',
    'OTHERS',
  ];
  return allowed.includes(upper as FeaturedCarCategory)
    ? (upper as FeaturedCarCategory)
    : undefined;
}

export function useGetFeaturedCarsQuery(
  options?: QueryHookOptions<GetFeaturedCarsQueryData, GetFeaturedCarsQueryVars>,
) {
  return useQuery<GetFeaturedCarsQueryData, GetFeaturedCarsQueryVars>(GET_FEATURED_CARS, options);
}
